import { useQuery } from "@tanstack/react-query";
import { productsApi } from "../api/productsApi";
import { productsKeys } from "../api/productsKeys";

export const useProduct = (documentId, params) =>
  useQuery({
    queryKey: productsKeys.detail(documentId),
    queryFn: () => productsApi.get(documentId, params),
    enabled: Boolean(documentId),
  });
